import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';
import { quotationsListTypes } from './actionTypes';
import {
    getQuotationsListSuccess,
    getQuotationsListFail,
    getMilestoneConfigQTSuccess,
    getMilestoneConfigQTFail,
} from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchQT = () => {
    controller.abort();
    controller = new AbortController();
    signal = controller.signal;
};

export const fetchQuotationsList = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetQuotationList(Quotation: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order: "${order}",
      ${dynamicFilterCF}
      ${dynamicFilter}
    }, Pagination: {
      sizePage: ${sizePerPage},
      actualPage: ${page}
    }) {
      CountItems
      QuotationData {
        id
        clientId
        GUID
        Number
        URL
        CreatedOn
        LogDate
        ExpirationDate
        CreatedByName
        Version
        IssuedByName
        IssuedByGUID
        ContactName
        ContactGUID
        Status
        Direction
        Service
        Frequency
        IsHazardous
        IsOpenQuote
        PaymentTerms
        ExchangeRate
        CurrencyCode
        OriginPortCode
        OriginPortName
        OriginCountryCode
        DestinationPortCode
        DestinationPortName
        DestinationCountryCode
        DescriptionOfGoods
        TotalAmountInCurrency
        ItemsAmountInCurrency
        ChargesAmountInCurrency
        TaxAmountInCurrency
        TotalValue
        TotalAmount
        TotalTradeDiscount
        TotalTradeDiscountInCurrency
        TotalPieces
        ChargeableWeight
        WeightUnit
        VolumeUnit
        VolumeWeightUnit
        HasFiles
      }
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        signal,
        body: JSON.stringify({ query }),
    }).then((res) => res.json());

    return response.data.GetQuotationList;
};

function* fetchQuotationsListSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchQuotationsList, data.payload);
        yield put(getQuotationsListSuccess(response));
    } catch (error) {
        yield put(getQuotationsListFail(error));
    }
}

function* getMilestoneConfigQT(data: any): any {
    try {
        const response: Promise<any> = yield call(getMilestoneConfigOperation, {
            OperationType: 'QT',
            ...data?.payload,
        });
        yield put(getMilestoneConfigQTSuccess(response));
    } catch (error) {
        yield put(getMilestoneConfigQTFail(error));
    }
}

function* quotationsListSaga() {
    yield takeLatest(quotationsListTypes.GET_QUOTATIONS_LIST, fetchQuotationsListSaga);
    yield takeLatest(quotationsListTypes.GET_MILESTONESCONFIG_QT, getMilestoneConfigQT);
}

export default quotationsListSaga;
